import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import * as Sentry from '@sentry/vue';
import { createI18n } from 'vue-i18n';
import PrimeVue from 'primevue/config';
import Tooltip from 'primevue/tooltip';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import MyTheme from './theme';
import './style.css';

import '@fontsource-variable/bricolage-grotesque';
import '@mdi/font/css/materialdesignicons.css';
import './main.css';

const i18n = createI18n({
  fallbackLocale: 'en',
});

const app = createApp(App);

app.directive('tooltip', Tooltip);

app
  .use(i18n)
  .use(PrimeVue, {
    theme: {
      preset: MyTheme,
      options: {
        darkModeSelector: '.p-dark',
      },
    },
  })
  .use(ToastService)
  .use(ConfirmationService)
  .use(router)
  .mount('#app');

// Only initialize Sentry in production
if (import.meta.env.PROD) {
  Sentry.init({
    app,
    dsn: 'https://ea2ad9876a52ccb12e00ce37f56f54fc@o4508907193696256.ingest.de.sentry.io/4509208376770640',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    // sendDefaultPii: true,
  });
}
